import { createSortOption } from "@nosto/preact"

// Get the dynamic per-page count from the product-list element
// This accounts for marketing units (adjusted_products_per_page in Liquid)
function getSerpSize() {
    const productList = document.querySelector('.product-list');
    if (productList) {
        const perPage = parseInt(productList.getAttribute('per-page'));
        if (perPage && !isNaN(perPage)) {
            return perPage;
        }
    }
    // Fallback to default if attribute not found
    return 24;
}

export const sizes = [35, 72, 108]

export const sortOptions = [
    createSortOption("score", "Most relevant", { field: "_score", order: "desc" }),
    createSortOption("-price", "Price descending", { field: "price", order: "desc" }),
    createSortOption("price", "Price ascending", { field: "price", order: "asc" })
]

export const defaultConfig = {
    sort: sortOptions[0],
    //serpSize: getSerpSize(),
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5
}
